import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { ActionIconTemplate } from './ActionIconTemplate';
export const CustomActionIcon = forwardRef(({ icon, ...props }, ref) => (_jsx(ActionIconTemplate, { ref: ref, ...props, icon: icon })));
